import { getDataMapper, mapField } from "@/shared";

export const mapCampaignToServer = getDataMapper(
    {
        name: mapField("name"),
        subject: mapField("subject"),
        from_name: mapField("fromName"),
        from_email: mapField("fromEmail"),
        template: mapField("template"),
        body_html: mapField("bodyHtml"),
        segment_json: mapField("segmentJson"),
        director_ids: mapField("directorIds"),
        throttle_per_minute: mapField("throttlePerMinute"),
        scheduled_at: mapField("scheduledAt"),
    },
    {
        shouldAvoidUndefined: true,
    },
);
